// skew (true/false), stretch (true/false), friction (%), timerInterval (ms)
export const defaultSimulationOptions = [1, 0, 10, 50]

export const defaultOutputOptions = {
  // X, Y, time
  offset: [0, 0, 0],
  scale: [100, 100, 100]
}
